module.exports = __webpack_public_path__ + "img/point.fac853b0.svg";